var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({class:("icon " + (_vm.svgClass ? _vm.svgClass : '')),attrs:{"aria-hidden":"true"}},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }